module.exports = __webpack_public_path__ + "static/media/blackjack_multi_hand.concept.fef7134c.jpeg";